import React, { useEffect, useState } from 'react';
import { fetchUserById } from "../../../service/userService";
import propTypes from 'prop-types';
import { Modal } from "antd";
import { PlusCircle } from "feather-icons-react/build/IconComponents";

const ViewUser = ({ open, userId, onClose }) => {

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [roleName, setRoleName] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  useEffect(() => {
    const fetchUserDetails = async (userId) => {
      try {
        const userData = await fetchUserById(userId);
        
        setName(userData.name);
        setPhone(userData.phone);
        setEmail(userData.email);
        setRoleName(userData.role?.roleName || "N/A"); // Display role name directly
        
        if (userData.profile_picture) {
           // If it's a URL (from backend), use it directly. If it were a file object (not expected here), createObjURL.
           // Assuming it's a URL string based on EditUser.
           setImagePreview(userData.profile_picture);
        } else {
            setImagePreview(null);
        }

      } catch (error) {
        console.error('Error fetching user details:', error);
      }
    };

    if (userId && open) {
      fetchUserDetails(userId);
    }
  }, [userId, open]);

    const handleImageClick = () => {
        if(imagePreview) setShowPreview(true);
    };

    const handleClosePreview = () => {
        setShowPreview(false);
    };

  return (
    <div>
      <Modal zIndex={2000} title="View User" footer={false} open={open} onCancel={onClose}>
        <div className="row">
          <div className="col-lg-12">
            <div className="new-employee-field">
              <span>User profile</span>
              <div className="profile-pic-upload mb-2">
                <div className="profile-pic">
                  {imagePreview ? (
                    <img
                      src={imagePreview}
                      alt="Profile"
                      style={{
                        width: "150px",
                        height: "118px",
                        borderRadius: "10%",
                        objectFit: "cover",
                        cursor: "pointer"
                      }}
                      onClick={handleImageClick}
                    />
                  ) : (
                    <div style={{
                        width: "150px",
                        height: "118px",
                        borderRadius: "10%",
                        border: "1px dashed #ccc",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#ccc"
                    }}>
                      <PlusCircle className="plus-down-add" />
                      <span>No Image</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="input-blocks">
              <label>User Name</label>
              <input type="text" value={name} className="form-control" disabled />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="input-blocks">
              <label>Phone</label>
              <input type="text" value={phone} className="form-control" disabled />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="input-blocks">
              <label>Email</label>
              <input type="text" value={email} className="form-control" disabled />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="input-blocks">
              <label>Role</label>
              <input type="text" value={roleName} className="form-control" disabled />
            </div>
          </div>
        </div>
        <div className="modal-footer-btn">
             <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                <button type="button" className="btn btn-cancel" onClick={onClose}>
                    Close
                </button>
            </div>
        </div>
      </Modal>

      <Modal
        zIndex={2001}
        title="Profile picture"
        open={showPreview}
        footer={null}
        onCancel={handleClosePreview}
        centered
      >
        <img
          src={imagePreview}
          alt="Preview"
          style={{ width: "100%", borderRadius: "10px" }}
        />
      </Modal>
    </div>
  );
};

ViewUser.propTypes = {
  userId: propTypes.string,
  onClose: propTypes.func.isRequired,
  open: propTypes.bool,
};

export default ViewUser;
